module.exports = __webpack_public_path__ + "static/high_five-4dea1bb67bd514e542815fcb4b3df21b.svg";